import React,{Component} from "react";
import {  Row, Col, Card, CardHeader, CardBody, Button,
Form,
  FormInput,
  FormGroup,
 
   ListGroup,
  ListGroupItem,
  
  FormSelect,
 } from "shards-react";

import { AtomSpinner } from 'react-epic-spinners';
import { toast } from 'react-toastify';
import firebase from '../firebase';



export default class AddHomeWork extends Component{

  constructor(props) {
    super(props);
  
    this.state = {loading:false,
                  class_list:[],
                  subjects:[],
                  selected_class:"Select Class",
                  selected_subject:"Select Subject",
                  title:undefined,
                  description:undefined,
                };
    this.get_subjects_list = this.get_subjects_list.bind(this);
    this.get_class_list = this.get_class_list.bind(this);
    this.get_data = this.get_data.bind(this);
   
  }

  get_subjects_list = ()=>{
    var that = this;
    this.setState({loading:true});
    firebase.firestore().collection('Subject').doc('list').get().then(function(doc){
        if(doc.exists){
            that.setState({subjects:doc.data().list,loading:false});
        }
        else{
          that.setState({loading:false});
        }

    }).catch(function(err){
           toast('Unable to get subjects list', {containerId: 'A'});
          that.setState({loading:false});
      })
  }

  get_class_list = ()=>{
        this.setState({class_list:this.props.class_list});
  }

  componentDidMount(){
      this.get_class_list();
      this.get_subjects_list();
  }

  get_data = ()=>{
    var data = {
      class_name:this.state.selected_class,
      subject:this.state.selected_subject,
      title:this.state.title,
      description:this.state.description
    }

    return data;
  }

  add_data = (evt)=>{

      evt.preventDefault();

      console.log(this.state);
      if(this.state.selected_subject==="Select Subject"){
              toast("Kindly Select Subject", {containerId: 'A'});
              return;
      }
      if(this.state.selected_class==="Select Class"){
              toast("Kindly Select Class", {containerId: 'A'});
              return;
      }
      if(this.state.title===undefined || this.state.description===undefined){
          toast("Kindly fill all details",{containerId:'A'});
          return;
      }

      var that = this;
      
      var func_ref = firebase.functions().httpsCallable('AddHomeWork');  
                         
          
        this.setState({loading:true});
        var data = this.get_data();      

        func_ref(data).then(function(result) {
                  // Read result of the Cloud Function.
                  var data = result.data;
                  console.log(data);
                  if(data.status==="success"){
                        console.log("Document succesfully added!");
                        toast('HomeWork  Added Successfully !', {containerId: 'A'});

                   }
                  else{
                        toast(data.error.message, {containerId: 'A'});
                        console.log(data.error.message);
                  }
                  that.setState({loading:false});

        }).catch(function(error) {
                  // Getting the Error details.
                  //var code = error.code;
                  //var message = error.message;
                  //var details = error.details;
                  // ...
                  console.log(error);
                  that.setState({loading:false});
                  toast("unable to add Student", {containerId: 'A'});
        });

      


  }






	render(){
		return(

	<Card small className="h-100" style={{margin:"5%"}}>
        <CardHeader className="border-bottom">
          <h6 className="m-0">Add Home Work</h6>
        </CardHeader>
        <CardBody className="pt-0">
          <ListGroup flush>
    <ListGroupItem className="p-3">
      <Row>
        <Col>
        	
          <Form onSubmit={this.add_data}>


          <SelectClass onChangeHandler={(evt)=>{this.setState({selected_class:evt.target.value})}}
                  loading={this.state.loading}
                  class_list={this.state.class_list} />

            <FormGroup>
            	<label htmlFor="feInputClass" style={{color:'blue'}}>Subject</label>
      			 
              <SelectSubject onChangeHandler={(evt)=>{this.setState({selected_subject:evt.target.value})}}
                  loading={this.state.loading}
                  subject_list={this.state.subjects} />
      			
    		</FormGroup>


            <FormGroup>
              <label htmlFor="feInputAddress" style={{color:'blue'}}>Homework Title</label>
              <FormInput id="feInputAddress" placeholder="Title"  onChange={(evt)=>{this.setState({title:evt.target.value})}}/>
            </FormGroup>

            <FormGroup>
              <label htmlFor="feInputAddress2" style={{color:'blue'}}>Homework Description</label>
              <FormInput
                onChange={(evt)=>{this.setState({description:evt.target.value})}}
                id="feInputAddress2"
                placeholder="Description"
              />
            </FormGroup>

          { !this.state.loading && 
            <div>
              <Button type="submit">Add new HomeWork</Button>
              <Button type="button" style={{marginLeft: '5%'}} theme="danger" onClick={()=>this.props.cancel()}>Cancel</Button>
            </div>
          }
          { 
              
                  (this.state.loading) &&
                    <div style={{margin: '10%',marginLeft: '40%'}}>
                        <AtomSpinner color="blue" />            
                    </div>
          

          }
          </Form>
        </Col>
      </Row>
    </ListGroupItem>
  </ListGroup>
        </CardBody>
      </Card>
				
		)
	}
}

class SelectClass extends Component{
  render(){
    return(

        <Row form>
              <Col md="12" className="form-group">
                <label htmlFor="feEmailAddress" style={{color:'blue'}}>Class</label>
                <FormSelect onChange={this.props.onChangeHandler}>
                                          <option>{this.props.loading?"Loading...":(this.props.class_list.length>0?"Select Class":"No Classes Available")}</option>
                                          {

                                              this.props.class_list.map((item,i)=>{
                                                             return (<option key={i}>{item}</option>)
                                                })
                                           }
                </FormSelect>
            </Col>
              
        </Row>


      )
  }
}

class SelectSubject extends Component{
  render(){
    return(

                <FormSelect onChange={this.props.onChangeHandler}>
                                          <option>{this.props.loading?"Loading...":(this.props.subject_list.length>0?"Select Subject":"No Classes Available")}</option>
                                          {

                                              this.props.subject_list.map((item,i)=>{
                                                             return (<option key={i}>{item.subjectname}</option>)
                                                })
                                           }
                </FormSelect>
            


      )
  }
}

